import { Divider, SxProps, Theme } from '@mui/material'
import colors from '../../constants/colors'

interface IProps {
  border?: string
  color?: string
  orientation?: 'horizontal' | 'vertical'
  sx?: SxProps<Theme>
  className?: string
}

const DividerTAG = ({
  border = '1px',
  color = colors.TAG_LINES_GRAY,
  orientation = 'horizontal',
  sx,
  className = '',
}: IProps) => {
  return (
    <Divider
      className={`t-separator ${className}`}
      variant='middle'
      orientation={orientation}
      sx={{ width: '100%', border: `${border} solid ${color}`, ...sx }}
    />
  )
}

export default DividerTAG
